<template>
  <aside class="pricing-cta radius-medium pd-big mn-b-medium">
    <div class="pricing-cta__glow" aria-hidden="true"></div>
    <div class="pos-relative z-1">
      <h3 class="pricing-cta__title mn-b-medium">{{ headline }}</h3>
      <p class="pricing-cta__sub t-grey mn-b-medium">{{ sub }}</p>
      <router-link :to="to" class="button button--xl pricing-cta__btn">
        {{ ctaLabel }}
      </router-link>
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue';

// Блок-CTA на тарифы внутри статьи блога. Данные приходят из content[]-блока
// (генерит контент-пайплайн): { headline, sub, ctaLabel, to }. Project-specific,
// регистрируется через интерфейс модуля constructor (client.js → blockManager.register).
defineOptions({ inheritAttrs: false });

const props = defineProps({
  // Viewer прокидывает сам блок как `prop` (и `component`).
  prop: { type: Object, default: () => ({}) },
});

const data = computed(() => props.prop?.content || {});
const headline = computed(() => data.value.headline || 'Хватит откликаться вручную');
const sub = computed(() => data.value.sub || 'Traffers сам откликается за вас на подходящие вакансии hh.ru — с AI-скорингом и персональным сопроводительным под каждую.');
const ctaLabel = computed(() => data.value.ctaLabel || 'Попробовать Traffers');
const to = computed(() => data.value.to || '/dashboard/subscription');
</script>

<style scoped>
.pricing-cta {
  position: relative;
  overflow: hidden;
  background: linear-gradient(168deg, rgba(var(--main), 0.10) 0%, transparent 55%), rgba(var(--light), 0.85);
  border: 1px solid rgba(var(--main), 0.30);
}

.pricing-cta__glow {
  position: absolute;
  inset: -40px -40px auto auto;
  width: 240px;
  height: 240px;
  background: radial-gradient(50% 50% at 50% 50%, rgba(var(--main), 0.18) 0%, transparent 70%);
  pointer-events: none;
}

.pricing-cta__badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: var(--radius-pill);
  background: rgb(var(--main));
  color: #fff;
}

.pricing-cta__title {
  background: linear-gradient(135deg, rgb(var(--black)) 30%, rgb(var(--main)) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.pricing-cta__sub {
  max-width: 52ch;
  line-height: 1.5;
}

.pricing-cta__btn {
  display: inline-flex;
  background: rgb(var(--main));
  color: #fff;
  font-weight: 600;
  box-shadow: 0 4px 20px rgba(var(--main), 0.25);
}

.pricing-cta__btn:hover {
  filter: brightness(1.08);
  box-shadow: 0 4px 28px rgba(var(--main), 0.35);
}
</style>
